import { PageHeader } from "@/components/ui/page-header";
import { LogsViewer } from "./components/log-viewer";

export default function LogsPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Logs" description="View and filter application logs" />
      <LogsViewer />
    </div>
  );
}
